import ButtonApi from '../../../../components/ButtonApi';
import { useCosmos } from '../../../../helpers/cosmosHelper';
import { useEvent } from '../EventProvider';
import { useMint } from './MintNftProvider';

const StepLast = () => {
  const [{ username, suffix, mintFee, feeToken, chainName, isDisabled, onNext, onPrevious }] = useMint();
  const [{ campaign }] = useEvent();
  const [{ xionBalance, refreshBalance }] = useCosmos();

  const hasDynamicFee = campaign?.mintFeeConfig?.dynamicPriceOnUsername;

  const caption = mintFee ? (
    <>
      Mint fee of {mintFee} (${String(feeToken).toUpperCase()}) applicable on {chainName}
    </>
  ) : (
    <>Mint on {chainName}</>
  );

  return (
    <>
      <h2>The Naming Ritual</h2>
      <p>To begin the path, you need a name for your Identity Relic, a name that you own, unique to you.</p>
      <div className='nftname_wrapper'>
        <div className='nftname_container'>
          <input placeholder='Enter your username' disabled={true} value={username} />
          <div className='nftname_suffix'>{suffix}</div>
        </div>
        {username?.length > 0 && <h4>USERNAME CLAIM FEE - {mintFee} XION</h4>}
        <p>
          {username}.{suffix} IS AVAILABLE
        </p>
      </div>

      {+xionBalance < +mintFee ? (
        <>
          <p className='low_balance'>
            Low Balance: {xionBalance}($XION)
            <a href='https://getxion.com' target='_blank'>
              (GET XION)
            </a>
          </p>
          <button onClick={refreshBalance}>Refresh</button>
          <p className='logout_button' onClick={onPrevious}>
            Change Username
          </p>
        </>
      ) : (
        <ButtonApi className='primary' onClick={onNext} disabled={isDisabled}>
          Continue
        </ButtonApi>
      )}
    </>
  );
};

export default StepLast;
